<template>
  <div class="banner-form default-form">
    <div class="columns">
      <div class="column">
        <div class="row">
          <label>Изображение</label>
          <div class="image-container">
            <img class="image" :src="model.image_url"
            />
            <vue-dropzone
              id="dropzone"
              class="dropzone"
              ref="imageDropzone"
              :options="dropzoneOptions"
              :destroyDropzone="false"
              @vdropzone-success="success"
              @vdropzone-file-added="dropzoneAdded"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import vue2Dropzone from 'vue2-dropzone';
import { mapActions, mapGetters } from 'vuex';

import options from '@/config/dropzone-options';

export default {
  name: 'banner-form',

  components: {
    vueDropzone: vue2Dropzone,
  },

  props: {
    model: Object,
  },

  computed: {
    ...mapGetters({
      uploadResponse: 'util/uploadResponse',
    }),

    dropzoneOptions() {
      return { ...options, url: this.model.image_url };
    },
  },

  methods: {
    ...mapActions({
      updateStaticFile: 'util/updateStaticFile',
    }),

    success(file, response) {
      const url = process.env.VUE_APP_STATIC_URL + response.data.data.name;
      this.$emit('imageUpdated', url);
      this.$refs.imageDropzone.removeAllFiles();
    },

    async dropzoneAdded(file) {
      if (!file.manuallyAdded) {
        const formData = new FormData();
        formData.append('file', file);

        await this.updateStaticFile({
          formData,
          listener: this.updateProgress,
          file,
          url: this.model.image_url
        });

        this.$refs.imageDropzone.dropzone
          .emit('complete', file)
          .emit('success', file, this.uploadResponse);
      }
    },

    updateProgress(event, file) {
      const percentCompleted = Math.floor((event.loaded * 100) / event.total);

      this.$refs.imageDropzone.dropzone.emit(
        'uploadprogress',
        file,
        percentCompleted
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-form {
  .image-container {
    position: relative;
    width: 700px;
    height: auto;

    .image {
      width: 100%;
      height: 100%;
    }

    .dropzone {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>